import twemoji from '@twemoji/api';
export function renderEmojis(baseUrl, el) {
    twemoji.parse(el, {
        base: `${baseUrl}twemoji/`,
    });
}
//# sourceMappingURL=emoji.js.map